import { render, staticRenderFns } from "./supportDocumentModal.vue?vue&type=template&id=a88b8b32"
import script from "./supportDocumentModal.vue?vue&type=script&lang=js"
export * from "./supportDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports